import React, { ReactElement } from "react";
import Layout from "../../../components/layout";
import ShopRecycleBinList from "../../../components/Shops/Products/recycle-bin";

const ShopRecycleBinPage = (): ReactElement => {
  return (
    <Layout>
      <ShopRecycleBinList />
    </Layout>
  );
};

export default ShopRecycleBinPage;
